const topics = [
  {
    label: '🔥 热播剧集',
    count: '2,386部',
    desc: '红桃视频、樱桃视频同步热播电视剧高清全集',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    label: '🎬 热门短剧',
    count: '5,120部',
    desc: '茄子视频、糖心视频短剧合集每日更新',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    label: '📺 综艺娱乐',
    count: '3,850部',
    desc: '全网热门综艺节目一站式收录',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    label: '🎯 新片速递',
    count: '1,240部',
    desc: '各大平台最新上线内容第一时间收录',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    label: '⭐ 高分推荐',
    count: '890部',
    desc: '精选口碑佳作，好片不迷路',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    label: '💫 经典回顾',
    count: '3,670部',
    desc: '经典电视剧、电影重温专区',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    label: '🎭 古装剧场',
    count: '1,580部',
    desc: '热门古装剧集分类整理',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    label: '💕 都市情感',
    count: '2,210部',
    desc: '都市题材电视剧精选合集',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    label: '🔍 悬疑烧脑',
    count: '1,050部',
    desc: '高分悬疑推理剧全收录',
    color: 'bg-secondary-100 text-secondary-700',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            按类型快速浏览全网热门视频资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${item.color} bg-opacity-20`}>
                <span className="text-lg font-bold">{i + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 whitespace-nowrap">{item.label}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 self-center">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}